__turbopack_context__.v({
  "alert": "NUsLbq_alert",
  "alertWrap": "NUsLbq_alertWrap",
  "alertWrapClosing": "NUsLbq_alertWrapClosing",
  "closeButton": "NUsLbq_closeButton",
  "extraContent": "NUsLbq_extraContent",
  "heading": "NUsLbq_heading",
  "message": "NUsLbq_message",
});
